import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressNameState = string;

const initialState: ContractProgressNameState = '';

export default function reducer(
  state: ContractProgressNameState = initialState,
  action: ContractProgressAction
): ContractProgressNameState {
  switch (action.type) {
    default:
      return state;
  }
}
